import { useInitData, useOutboundUuid, useUserData } from '../../../../../hooks'
import { isStaffUser } from '../../../../../utils/user'
import { Header } from '../../../../Modal'
import { getRequestProfileTabEmailsThreadPageLink } from '../../RequestProfileTabEmails.utils'

import * as styles from './RequestProfileTabEmailsThreadModalHeader.module.css'

function RequestProfileTabEmailsThreadModalHeader({
  isSkeleton,
  mailUuid,
  persistentActions,
  requestId,
  subject,
  onClose,
  onMinimize,
}) {
  const { availableSections } = useInitData()

  const currentUser = useUserData()

  const outboundUuid = useOutboundUuid()

  const isStaff = isStaffUser(currentUser)

  const profileLink = getRequestProfileTabEmailsThreadPageLink({
    availableSections,
    isStaff,
    mailUuid,
    outboundUuid,
    requestId,
  })

  return (
    <Header
      headlineClassName={styles.title}
      isSkeleton={isSkeleton}
      openInNewWindowLink={profileLink}
      persistentActions={persistentActions}
      text={subject}
      onClose={onClose}
      onMinimize={isStaff && !outboundUuid ? onMinimize : null}
    />
  )
}

export default RequestProfileTabEmailsThreadModalHeader
